import { Button } from '@mc/design-system'
import { paths } from '@mc/paths'

import { trackSubcatPillClick } from '../../events'

interface SubcatPillProps {
  categoryName: string
  subcatName: string
  subcatSlug: string
}

export const SubcatPill = ({
  subcatName,
  subcatSlug,
  categoryName,
}: SubcatPillProps) => (
  <Button
    className='mc-mt-2 mc-text-h7 mc-mr-1 mc-py-1 mc-px-3 mc-background--color-medium mc-corners--1'
    size='small'
    kind='secondary'
    as='a'
    href={paths.subcategoryPage(subcatSlug)}
    onClick={() => trackSubcatPillClick(subcatName, categoryName)}
  >
    {subcatName}
  </Button>
)
